import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';
import ReactGA from 'react-ga4';
import { BrowserTracing } from '@sentry/tracing';
import './i18n';
import { parseUrl } from './helpers/parseUrl';
import { types } from './constants';

import ErrorBoundary from './ErrorBoundary';

if (process.env.NODE_ENV === 'production') {
  // SENTRY
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.5,
  });

  // GOOGLE ANALYTICS - Initialize with appropriate ID based on website
  const hostname = window.location.hostname;
  const countryDetails = parseUrl(hostname);

  const isScotland = countryDetails.countryType === types.countryType.SCOTLAND;
  const analyticsId = isScotland
    ? process.env.REACT_APP_ANALYTICS_ID_ADP
    : process.env.REACT_APP_ANALYTICS_ID_PIP;

  if (analyticsId) {
    ReactGA.initialize(analyticsId);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    {/* <React.StrictMode> */}
    <App ReactGA={ReactGA} />
    {/* </React.StrictMode> */}
  </ErrorBoundary>
);

reportWebVitals();
